import { useEffect } from 'react';

import { useActorRef } from '@xstate/react';

import { useFeatureFlag } from '@order/LaunchDarkly';
import { useTelemetry } from '@order/Telemetry';

import { adjustInitializationMachine } from '../../machine/adjust-initialization-machine';
import {
  hasOptedInToOneTrust,
  handleAdjustUnmount,
  subscribeToOneTrustConsentChanged,
  getAdjustInitializer,
} from '../../utils';

// ─────────────────────────────────────────────────────────────────────────────

export const useAdjustInitialization = (isTrackingAllowed: boolean, userId?: string | null) => {
  const isAdjustEnabled = useFeatureFlag('permanent-adjust-enabled');
  const { track } = useTelemetry();

  const actorRef = useActorRef(
    adjustInitializationMachine.provide({
      guards: {
        isAdjustEnabled: () => isAdjustEnabled,
        isTrackingAllowed: () => isTrackingAllowed && hasOptedInToOneTrust(),
      },
      actions: {
        initialize: () => getAdjustInitializer(track),
      },
    }),
  );

  useEffect(() => {
    actorRef.send({ type: 'SYNC_CUSTOMER', userId });
  }, [actorRef, userId, isAdjustEnabled, isTrackingAllowed]);

  useEffect(() => {
    return subscribeToOneTrustConsentChanged(() => {
      actorRef.send({ type: 'SYNC_CUSTOMER', userId });
    });
  }, [actorRef, userId]);

  useEffect(() => {
    return () => {
      handleAdjustUnmount();
    };
  }, []);

  return actorRef;
};
